/**
 * [PPMシェア] グラフのX軸として利用する日付タイプ
 */
export const PPM_SHARE_GRAPH_DATE_LABEL_TYPE = {
  THIRTEEN_WEEKS: '13weeks',
  TWENTYSIX_WEEKS: '26weeks',
  THIRTEEN_MONTHS: '13months',
  ANY: 'any',
} as const;
